import { motion } from 'framer-motion'
import { FileText, Bot, BarChart3 } from 'lucide-react'

const HowItWorks = () => {
  const steps = [
    {
      icon: FileText,
      title: "Upload or Invite",
      description: "Upload candidate resumes or invite via email. Bring your ATS export or CSV."
    },
    {
      icon: Bot,
      title: "AI Interviews",
      description: "Our AI schedules, manages slots, and conducts initial interviews aligned to the role."
    },
    {
      icon: BarChart3,
      title: "Actionable Insights",
      description: "Receive concise summaries, skills ratings, and next-step recommendations."
    }
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  }

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  }

  return (
    <section id="how" className="section bg-white">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Three steps from resume to results.
          </p>
        </div>

        <motion.div 
          className="grid md:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="text-center p-8 bg-white rounded-2xl border border-gray-100 hover:border-primary-200 hover:shadow-lg transition-all duration-300 group hover:-translate-y-1"
              variants={itemVariants}
            >
              <div className="w-16 h-16 mx-auto mb-6 bg-primary-50 rounded-2xl flex items-center justify-center group-hover:bg-primary-100 transition-colors duration-300">
                <step.icon className="w-8 h-8 text-primary-500" />
              </div>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {step.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}

export default HowItWorks
